__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-07-15-1784112086-stable-dev/";